/* Supported url-parameters for filtering out units, based on the users search criteria */
export const URL_PARAMS = {
    priceCollectiveFrom: 'price_collective_from',
    priceCollectiveTo: 'price_collective_to',
    priceFrom: 'price_from',
    priceTo: 'price_to',
    areaFrom: 'area_from',
    areaTo: 'area_to',
    noOfBedroomsFrom: 'min_bedrooms',
    preview: 'preview',
};

/* Table constants */
export const UNIT_APARTMENT = {
    Header: 'Enhet',
    accessor: 'apartment',
};

export const UNIT_FLOOR = {
    Header: 'Etasje',
    accessor: 'floor',
};

export const UNIT_BEDROOMS = {
    Header: 'Soverom',
    accessor: 'bedrooms',
};

export const UNIT_SIZE = {
    Header: 'Areal',
    accessor: 'primaryRoomArea',
};

export const UNIT_PRICE = {
    Header: 'Totalpris',
    accessor: 'totalPrice',
};

export const UNIT_FLOORPLAN = {
    Header: '',
    accessor: 'floorPlan',
};
